// This file is auto-generated by @hey-api/openapi-ts

import type {
    ActivateUserResponse,
    AnalyzeBlobStorageResponse,
    ConfirmLessonResponse,
    ConfirmSchoolRequestUpdateResponse,
    CreateAnswerResponse,
    CreateCollaboratorLinkResponse,
    CreateEditionResponse,
    CreateLessonResponse,
    CreateNotificationResponse,
    CreateSchoolRequestResponse,
    CreateSchoolResponse,
    CreateWasteCollectionFormResponse,
    EditWasteContainerRequestResponse,
    GetAllAnswersResponse,
    GetAllEditionsResponse,
    GetAllLessonsResponse,
    GetAllNotificationsResponse,
    GetAllResponse,
    GetAllSchoolsResponse,
    GetAllWasteCollectionFormsResponse,
    GetAnswerByIdResponse,
    GetAnswersByLessonResponse,
    GetAnswersForSubmissionResponse,
    GetCollabActivityResponse,
    GetCollabInfoResponse,
    GetDefaultAnswerResponse,
    GetDefaultEditionResponse,
    GetDefaultLessonResponse,
    GetDefaultNotificationResponse,
    GetDefaultSchoolRequestResponse,
    GetDefaultSchoolResponse,
    GetDefaultWasteCollectionFormResponse,
    GetEditionByIdResponse,
    GetInboxNotificationsResponse,
    GetIstoricProfesoriResponse,
    GetLessonAnswersReportResponse,
    GetLessonByIdResponse,
    GetLessonProgressByTypeResponse,
    GetLessonsByTypeResponse,
    GetNotificationByIdResponse,
    GetNotificationReceiversStatusResponse,
    GetNotificationsReportResponse,
    GetOutboxNotificationsDeprecatedResponse,
    GetOwnSchoolResponse,
    GetOwnTicketRedemptionsResponse,
    GetOwnWasteContainerRequestsResponse,
    GetParentalApprovalByUserResponse,
    GetSchedulerRunsResponse,
    GetSchoolByIdResponse,
    GetSchoolRequestByIdResponse,
    GetSchoolRequestByUserIdResponse,
    GetSchoolRequestsReportResponse,
    GetSchoolsImportDataResponse,
    GetSchoolsReportResponse,
    GetSchoolsStatusReportResponse,
    GetStudentAnswersByLessonAndUserResponse,
    GetStudentLeaderboardResponse,
    GetTicketRedemptionsResponse,
    GetTicketTiersResponse,
    GetUserProfileResponse,
    GetUsersReportResponse,
    GetUsersWithSchoolRequestsReportResponse,
    GetWasteCollectionFormByIdResponse,
    GetWasteCollectionFormsReportResponse,
    GetWasteContainerRequestsReportCountersResponse,
    GetWasteContainerRequestsReportResponse,
    ListCollaboratorLinksResponse,
    MarkOwnSchoolRequestVideoSeenResponse,
    MarkWasteContainerRequestDeliveredResponse,
    MarkWasteContainerRequestProcessedResponse,
    ProcessWasteCollectionFormResponse,
    ReassignSchoolRequestToProfessorResponse,
    RedeemTicketResponse,
    SetCurrentEditionResponse,
    UpdateAnswerResponse,
    UpdateEditionResponse,
    UpdateLessonResponse,
    UpdateNotificationResponse,
    UpdateParticipantsResponse,
    UpdateSchoolRequestApprovalStatusResponse,
    UpdateSchoolRequestByAdminResponse,
    UpdateSchoolRequestResponse,
    UpdateSchoolResponse,
    UpdateTicketRedemptionStatusResponse,
    UpdateUserActivationResponse,
    UpdateUserByAdminResponse,
    UpdateUserProfileResponse,
    UpdateUserSignatureResponse,
    UpdateWasteCollectionFormByAdminResponse,
    UpdateWasteCollectionFormRealValuesResponse,
    UpdateWasteCollectionFormResponse,
    ValidateWasteCollectionFormResponse,
} from "./types.gen";

export const confirmSchoolRequestUpdateResponseTransformer = async (
    data: any,
): Promise<ConfirmSchoolRequestUpdateResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

const schoolRequestDtoSchemaResponseTransformer = (data: any) => {
    if (data.saptamanaVerdeStart) {
        data.saptamanaVerdeStart = new Date(data.saptamanaVerdeStart);
    }
    if (data.saptamanaVerdeEnd) {
        data.saptamanaVerdeEnd = new Date(data.saptamanaVerdeEnd);
    }
    if (data.videoVazutDt) {
        data.videoVazutDt = new Date(data.videoVazutDt);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.timestampRange) {
        data.timestampRange = rangeLocalDateTimeSchemaResponseTransformer(data.timestampRange);
    }
    if (data.acordGrupWhatsappDt) {
        data.acordGrupWhatsappDt = new Date(data.acordGrupWhatsappDt);
    }
    return data;
};

const rangeLocalDateTimeSchemaResponseTransformer = (data: any) => {
    if (data.start) {
        data.start = new Date(data.start);
    }
    if (data.end) {
        data.end = new Date(data.end);
    }
    return data;
};

export const getAllWasteCollectionFormsResponseTransformer = async (
    data: any,
): Promise<GetAllWasteCollectionFormsResponse> => {
    data = data.map((item: any) => {
        return wasteCollectionFormDtoSchemaResponseTransformer(item);
    });
    return data;
};

const wasteCollectionFormDtoSchemaResponseTransformer = (data: any) => {
    data.dataOrientativaColectare = new Date(data.dataOrientativaColectare);
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.validatedAt) {
        data.validatedAt = new Date(data.validatedAt);
    }
    if (data.processedAt) {
        data.processedAt = new Date(data.processedAt);
    }
    if (data.deeeOrderProcessedDate) {
        data.deeeOrderProcessedDate = new Date(data.deeeOrderProcessedDate);
    }
    if (data.dbaOrderProcessedDate) {
        data.dbaOrderProcessedDate = new Date(data.dbaOrderProcessedDate);
    }
    return data;
};

export const updateWasteCollectionFormResponseTransformer = async (
    data: any,
): Promise<UpdateWasteCollectionFormResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const createWasteCollectionFormResponseTransformer = async (
    data: any,
): Promise<CreateWasteCollectionFormResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const getTicketTiersResponseTransformer = async (data: any): Promise<GetTicketTiersResponse> => {
    data = data.map((item: any) => {
        return ticketTierDtoSchemaResponseTransformer(item);
    });
    return data;
};

const ticketTierDtoSchemaResponseTransformer = (data: any) => {
    if (data.availableFrom) {
        data.availableFrom = new Date(data.availableFrom);
    }
    if (data.availableTo) {
        data.availableTo = new Date(data.availableTo);
    }
    return data;
};

export const getTicketRedemptionsResponseTransformer = async (data: any): Promise<GetTicketRedemptionsResponse> => {
    data = pageTicketRedemptionDtoSchemaResponseTransformer(data);
    return data;
};

const pageTicketRedemptionDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return ticketRedemptionDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const ticketRedemptionDtoSchemaResponseTransformer = (data: any) => {
    if (data.redeemedDt) {
        data.redeemedDt = new Date(data.redeemedDt);
    }
    return data;
};

const pageableObjectSchemaResponseTransformer = (data: any) => {
    if (data.offset) {
        data.offset = BigInt(data.offset.toString());
    }
    return data;
};

export const redeemTicketResponseTransformer = async (data: any): Promise<RedeemTicketResponse> => {
    data = ticketRedemptionDtoSchemaResponseTransformer(data);
    return data;
};

export const getAllSchoolsResponseTransformer = async (data: any): Promise<GetAllSchoolsResponse> => {
    data = data.map((item: any) => {
        return schoolDtoSchemaResponseTransformer(item);
    });
    return data;
};

const schoolDtoSchemaResponseTransformer = (data: any) => {
    if (data.saptamanaVerdeStart) {
        data.saptamanaVerdeStart = new Date(data.saptamanaVerdeStart);
    }
    if (data.saptamanaVerdeEnd) {
        data.saptamanaVerdeEnd = new Date(data.saptamanaVerdeEnd);
    }
    if (data.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

export const updateSchoolResponseTransformer = async (data: any): Promise<UpdateSchoolResponse> => {
    data = schoolDtoSchemaResponseTransformer(data);
    return data;
};

export const createSchoolResponseTransformer = async (data: any): Promise<CreateSchoolResponse> => {
    data = schoolDtoSchemaResponseTransformer(data);
    return data;
};

export const listCollaboratorLinksResponseTransformer = async (data: any): Promise<ListCollaboratorLinksResponse> => {
    data = data.map((item: any) => {
        return collaboratorLinkDtoSchemaResponseTransformer(item);
    });
    return data;
};

const collaboratorLinkDtoSchemaResponseTransformer = (data: any) => {
    if (data.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    if (data.revokedAt) {
        data.revokedAt = new Date(data.revokedAt);
    }
    if (data.lastUsedAt) {
        data.lastUsedAt = new Date(data.lastUsedAt);
    }
    return data;
};

export const createCollaboratorLinkResponseTransformer = async (data: any): Promise<CreateCollaboratorLinkResponse> => {
    data = collaboratorLinkDtoSchemaResponseTransformer(data);
    return data;
};

export const getAllResponseTransformer = async (data: any): Promise<GetAllResponse> => {
    data = data.map((item: any) => {
        return schoolRequestDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const updateSchoolRequestResponseTransformer = async (data: any): Promise<UpdateSchoolRequestResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const createSchoolRequestResponseTransformer = async (data: any): Promise<CreateSchoolRequestResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const getAllNotificationsResponseTransformer = async (data: any): Promise<GetAllNotificationsResponse> => {
    data = data.map((item: any) => {
        return notificationDtoSchemaResponseTransformer(item);
    });
    return data;
};

const notificationDtoSchemaResponseTransformer = (data: any) => {
    if (data.sendAt) {
        data.sendAt = new Date(data.sendAt);
    }
    return data;
};

export const updateNotificationResponseTransformer = async (data: any): Promise<UpdateNotificationResponse> => {
    data = notificationDtoSchemaResponseTransformer(data);
    return data;
};

export const createNotificationResponseTransformer = async (data: any): Promise<CreateNotificationResponse> => {
    data = notificationDtoSchemaResponseTransformer(data);
    return data;
};

export const getAllLessonsResponseTransformer = async (data: any): Promise<GetAllLessonsResponse> => {
    data = data.map((item: any) => {
        return lessonDtoSchemaResponseTransformer(item);
    });
    return data;
};

const lessonDtoSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.deadline) {
        data.deadline = new Date(data.deadline);
    }
    if (data.punctajMaxim) {
        data.punctajMaxim = BigInt(data.punctajMaxim.toString());
    }
    return data;
};

export const updateLessonResponseTransformer = async (data: any): Promise<UpdateLessonResponse> => {
    data = lessonDtoSchemaResponseTransformer(data);
    return data;
};

export const createLessonResponseTransformer = async (data: any): Promise<CreateLessonResponse> => {
    data = lessonDtoSchemaResponseTransformer(data);
    return data;
};

export const getAllEditionsResponseTransformer = async (data: any): Promise<GetAllEditionsResponse> => {
    data = data.map((item: any) => {
        return editionDtoSchemaResponseTransformer(item);
    });
    return data;
};

const editionDtoSchemaResponseTransformer = (data: any) => {
    if (data.startDate) {
        data.startDate = new Date(data.startDate);
    }
    if (data.endDate) {
        data.endDate = new Date(data.endDate);
    }
    return data;
};

export const updateEditionResponseTransformer = async (data: any): Promise<UpdateEditionResponse> => {
    data = editionDtoSchemaResponseTransformer(data);
    return data;
};

export const createEditionResponseTransformer = async (data: any): Promise<CreateEditionResponse> => {
    data = editionDtoSchemaResponseTransformer(data);
    return data;
};

export const setCurrentEditionResponseTransformer = async (data: any): Promise<SetCurrentEditionResponse> => {
    data = editionDtoSchemaResponseTransformer(data);
    return data;
};

export const getAllAnswersResponseTransformer = async (data: any): Promise<GetAllAnswersResponse> => {
    data = data.map((item: any) => {
        return answerDtoSchemaResponseTransformer(item);
    });
    return data;
};

const answerDtoSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const updateAnswerResponseTransformer = async (data: any): Promise<UpdateAnswerResponse> => {
    data = answerDtoSchemaResponseTransformer(data);
    return data;
};

export const createAnswerResponseTransformer = async (data: any): Promise<CreateAnswerResponse> => {
    data = answerDtoSchemaResponseTransformer(data);
    return data;
};

export const editWasteContainerRequestResponseTransformer = async (
    data: any,
): Promise<EditWasteContainerRequestResponse> => {
    data = wasteContainerRequestReportDtoSchemaResponseTransformer(data);
    return data;
};

const wasteContainerRequestReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.procesataLaDt) {
        data.procesataLaDt = new Date(data.procesataLaDt);
    }
    if (data.livrataLaDt) {
        data.livrataLaDt = new Date(data.livrataLaDt);
    }
    return data;
};

export const markWasteContainerRequestProcessedResponseTransformer = async (
    data: any,
): Promise<MarkWasteContainerRequestProcessedResponse> => {
    data = wasteContainerRequestReportDtoSchemaResponseTransformer(data);
    return data;
};

export const markWasteContainerRequestDeliveredResponseTransformer = async (
    data: any,
): Promise<MarkWasteContainerRequestDeliveredResponse> => {
    data = wasteContainerRequestReportDtoSchemaResponseTransformer(data);
    return data;
};

export const updateWasteCollectionFormRealValuesResponseTransformer = async (
    data: any,
): Promise<UpdateWasteCollectionFormRealValuesResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const validateWasteCollectionFormResponseTransformer = async (
    data: any,
): Promise<ValidateWasteCollectionFormResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const processWasteCollectionFormResponseTransformer = async (
    data: any,
): Promise<ProcessWasteCollectionFormResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const updateWasteCollectionFormByAdminResponseTransformer = async (
    data: any,
): Promise<UpdateWasteCollectionFormByAdminResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const activateUserResponseTransformer = async (data: any): Promise<ActivateUserResponse> => {
    data = userDtoSchemaResponseTransformer(data);
    return data;
};

const userDtoSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.lastLogin) {
        data.lastLogin = new Date(data.lastLogin);
    }
    if (data.timestampRange) {
        data.timestampRange = rangeLocalDateTimeSchemaResponseTransformer(data.timestampRange);
    }
    if (data.school) {
        data.school = schoolDtoSchemaResponseTransformer(data.school);
    }
    if (data.parentalApprovalSubmittedAt) {
        data.parentalApprovalSubmittedAt = new Date(data.parentalApprovalSubmittedAt);
    }
    if (data.emailVerifiedDt) {
        data.emailVerifiedDt = new Date(data.emailVerifiedDt);
    }
    if (data.ultimCodOtpDt) {
        data.ultimCodOtpDt = new Date(data.ultimCodOtpDt);
    }
    return data;
};

export const updateUserActivationResponseTransformer = async (data: any): Promise<UpdateUserActivationResponse> => {
    data = userDtoSchemaResponseTransformer(data);
    return data;
};

export const updateUserSignatureResponseTransformer = async (data: any): Promise<UpdateUserSignatureResponse> => {
    data = userProfileDtoSchemaResponseTransformer(data);
    return data;
};

const userProfileDtoSchemaResponseTransformer = (data: any) => {
    if (data.schoolUpdatedAt) {
        data.schoolUpdatedAt = new Date(data.schoolUpdatedAt);
    }
    if (data.school) {
        data.school = schoolDtoSchemaResponseTransformer(data.school);
    }
    if (data.parentalApproval) {
        data.parentalApproval = parentalApprovalDtoSchemaResponseTransformer(data.parentalApproval);
    }
    if (data.schoolRequest) {
        data.schoolRequest = schoolRequestDtoSchemaResponseTransformer(data.schoolRequest);
    }
    return data;
};

const parentalApprovalDtoSchemaResponseTransformer = (data: any) => {
    if (data.submittedAt) {
        data.submittedAt = new Date(data.submittedAt);
    }
    return data;
};

export const getUserProfileResponseTransformer = async (data: any): Promise<GetUserProfileResponse> => {
    data = userProfileDtoSchemaResponseTransformer(data);
    return data;
};

export const updateUserProfileResponseTransformer = async (data: any): Promise<UpdateUserProfileResponse> => {
    data = userProfileDtoSchemaResponseTransformer(data);
    return data;
};

export const updateUserByAdminResponseTransformer = async (data: any): Promise<UpdateUserByAdminResponse> => {
    data = userDtoSchemaResponseTransformer(data);
    return data;
};

export const updateTicketRedemptionStatusResponseTransformer = async (
    data: any,
): Promise<UpdateTicketRedemptionStatusResponse> => {
    data = ticketRedemptionDtoSchemaResponseTransformer(data);
    return data;
};

export const reassignSchoolRequestToProfessorResponseTransformer = async (
    data: any,
): Promise<ReassignSchoolRequestToProfessorResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const markOwnSchoolRequestVideoSeenResponseTransformer = async (
    data: any,
): Promise<MarkOwnSchoolRequestVideoSeenResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const updateSchoolRequestApprovalStatusResponseTransformer = async (
    data: any,
): Promise<UpdateSchoolRequestApprovalStatusResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const updateSchoolRequestByAdminResponseTransformer = async (
    data: any,
): Promise<UpdateSchoolRequestByAdminResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const updateParticipantsResponseTransformer = async (data: any): Promise<UpdateParticipantsResponse> => {
    data = lessonAnswerDtoSchemaResponseTransformer(data);
    return data;
};

const lessonAnswerDtoSchemaResponseTransformer = (data: any) => {
    if (data.startedAt) {
        data.startedAt = new Date(data.startedAt);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.approvedAt) {
        data.approvedAt = new Date(data.approvedAt);
    }
    return data;
};

export const confirmLessonResponseTransformer = async (data: any): Promise<ConfirmLessonResponse> => {
    data = lessonAnswerDtoSchemaResponseTransformer(data);
    return data;
};

export const getWasteContainerRequestsReportResponseTransformer = async (
    data: any,
): Promise<GetWasteContainerRequestsReportResponse> => {
    data = pageWasteContainerRequestReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageWasteContainerRequestReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return wasteContainerRequestReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

export const getWasteContainerRequestsReportCountersResponseTransformer = async (
    data: any,
): Promise<GetWasteContainerRequestsReportCountersResponse> => {
    data = wasteContainerRequestContoareDtoSchemaResponseTransformer(data);
    return data;
};

const wasteContainerRequestContoareDtoSchemaResponseTransformer = (data: any) => {
    if (data.peStare) {
        data.peStare = peStareSchemaResponseTransformer(data.peStare);
    }
    if (data.peFel) {
        data.peFel = peFelSchemaResponseTransformer(data.peFel);
    }
    if (data.total) {
        data.total = BigInt(data.total.toString());
    }
    return data;
};

const peStareSchemaResponseTransformer = (data: any) => {
    if (data.inAsteptare) {
        data.inAsteptare = BigInt(data.inAsteptare.toString());
    }
    if (data.confirmata) {
        data.confirmata = BigInt(data.confirmata.toString());
    }
    if (data.livrata) {
        data.livrata = BigInt(data.livrata.toString());
    }
    return data;
};

const peFelSchemaResponseTransformer = (data: any) => {
    if (data.recipientDba) {
        data.recipientDba = BigInt(data.recipientDba.toString());
    }
    if (data.minirecipiente) {
        data.minirecipiente = BigInt(data.minirecipiente.toString());
    }
    return data;
};

export const getOwnWasteContainerRequestsResponseTransformer = async (
    data: any,
): Promise<GetOwnWasteContainerRequestsResponse> => {
    data = data.map((item: any) => {
        return wasteContainerRequestDtoSchemaResponseTransformer(item);
    });
    return data;
};

const wasteContainerRequestDtoSchemaResponseTransformer = (data: any) => {
    if (data.procesataLaDt) {
        data.procesataLaDt = new Date(data.procesataLaDt);
    }
    if (data.livrataLaDt) {
        data.livrataLaDt = new Date(data.livrataLaDt);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.trimisLaDt) {
        data.trimisLaDt = new Date(data.trimisLaDt);
    }
    return data;
};

export const getWasteCollectionFormByIdResponseTransformer = async (
    data: any,
): Promise<GetWasteCollectionFormByIdResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const getWasteCollectionFormsReportResponseTransformer = async (
    data: any,
): Promise<GetWasteCollectionFormsReportResponse> => {
    data = pageWasteCollectionFormReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageWasteCollectionFormReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return wasteCollectionFormReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const wasteCollectionFormReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.school) {
        data.school = schoolDtoSchemaResponseTransformer(data.school);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.timestampRange) {
        data.timestampRange = rangeLocalDateTimeSchemaResponseTransformer(data.timestampRange);
    }
    if (data.dataOrientativaColectare) {
        data.dataOrientativaColectare = new Date(data.dataOrientativaColectare);
    }
    if (data.validatedAt) {
        data.validatedAt = new Date(data.validatedAt);
    }
    if (data.processedAt) {
        data.processedAt = new Date(data.processedAt);
    }
    if (data.validatedAtRange) {
        data.validatedAtRange = rangeLocalDateTimeSchemaResponseTransformer(data.validatedAtRange);
    }
    if (data.processedAtRange) {
        data.processedAtRange = rangeLocalDateTimeSchemaResponseTransformer(data.processedAtRange);
    }
    if (data.dataOrientativaColectareRange) {
        data.dataOrientativaColectareRange = rangeLocalDateTimeSchemaResponseTransformer(
            data.dataOrientativaColectareRange,
        );
    }
    if (data.deeeOrderProcessedDate) {
        data.deeeOrderProcessedDate = new Date(data.deeeOrderProcessedDate);
    }
    if (data.dbaOrderProcessedDate) {
        data.dbaOrderProcessedDate = new Date(data.dbaOrderProcessedDate);
    }
    if (data.deeeOrderProcessedDateRange) {
        data.deeeOrderProcessedDateRange = rangeLocalDateTimeSchemaResponseTransformer(
            data.deeeOrderProcessedDateRange,
        );
    }
    if (data.dbaOrderProcessedDateRange) {
        data.dbaOrderProcessedDateRange = rangeLocalDateTimeSchemaResponseTransformer(data.dbaOrderProcessedDateRange);
    }
    return data;
};

export const getDefaultWasteCollectionFormResponseTransformer = async (
    data: any,
): Promise<GetDefaultWasteCollectionFormResponse> => {
    data = wasteCollectionFormDtoSchemaResponseTransformer(data);
    return data;
};

export const getUsersWithSchoolRequestsReportResponseTransformer = async (
    data: any,
): Promise<GetUsersWithSchoolRequestsReportResponse> => {
    data = pageProfesorReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageProfesorReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return profesorReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const profesorReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.timestampInregistrare) {
        data.timestampInregistrare = new Date(data.timestampInregistrare);
    }
    if (data.timestampFormularInscriere) {
        data.timestampFormularInscriere = new Date(data.timestampFormularInscriere);
    }
    if (data.saptamanaVerdeStart) {
        data.saptamanaVerdeStart = new Date(data.saptamanaVerdeStart);
    }
    if (data.saptamanaVerdeEnd) {
        data.saptamanaVerdeEnd = new Date(data.saptamanaVerdeEnd);
    }
    if (data.acordGrupWhatsappDt) {
        data.acordGrupWhatsappDt = new Date(data.acordGrupWhatsappDt);
    }
    if (data.profesorActualUltimaActivitate) {
        data.profesorActualUltimaActivitate = new Date(data.profesorActualUltimaActivitate);
    }
    return data;
};

export const getUsersReportResponseTransformer = async (data: any): Promise<GetUsersReportResponse> => {
    data = pageUserDtoSchemaResponseTransformer(data);
    return data;
};

const pageUserDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return userDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

export const getOwnTicketRedemptionsResponseTransformer = async (
    data: any,
): Promise<GetOwnTicketRedemptionsResponse> => {
    data = data.map((item: any) => {
        return ticketRedemptionDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const getStudentLeaderboardResponseTransformer = async (data: any): Promise<GetStudentLeaderboardResponse> => {
    data = pageStudentLeaderboardRowDtoSchemaResponseTransformer(data);
    return data;
};

const pageStudentLeaderboardRowDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return studentLeaderboardRowDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const studentLeaderboardRowDtoSchemaResponseTransformer = (data: any) => {
    if (data.puncteHomework) {
        data.puncteHomework = BigInt(data.puncteHomework.toString());
    }
    if (data.puncteMonthly) {
        data.puncteMonthly = BigInt(data.puncteMonthly.toString());
    }
    if (data.total) {
        data.total = BigInt(data.total.toString());
    }
    return data;
};

export const getSchoolByIdResponseTransformer = async (data: any): Promise<GetSchoolByIdResponse> => {
    data = schoolDtoSchemaResponseTransformer(data);
    return data;
};

export const getSchoolsStatusReportResponseTransformer = async (data: any): Promise<GetSchoolsStatusReportResponse> => {
    data = pageEditionReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageEditionReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return editionReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const editionReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.pointsLesson) {
        data.pointsLesson = BigInt(data.pointsLesson.toString());
    }
    if (data.pointsClassExercise) {
        data.pointsClassExercise = BigInt(data.pointsClassExercise.toString());
    }
    if (data.pointsPracticalActivity) {
        data.pointsPracticalActivity = BigInt(data.pointsPracticalActivity.toString());
    }
    if (data.pointsHomework) {
        data.pointsHomework = BigInt(data.pointsHomework.toString());
    }
    if (data.pointsDailyChallenge) {
        data.pointsDailyChallenge = BigInt(data.pointsDailyChallenge.toString());
    }
    if (data.pointsMonthlyChallenge) {
        data.pointsMonthlyChallenge = BigInt(data.pointsMonthlyChallenge.toString());
    }
    if (data.countLesson) {
        data.countLesson = BigInt(data.countLesson.toString());
    }
    if (data.countClassExercise) {
        data.countClassExercise = BigInt(data.countClassExercise.toString());
    }
    if (data.countPracticalActivity) {
        data.countPracticalActivity = BigInt(data.countPracticalActivity.toString());
    }
    if (data.countCollaboratorActivities) {
        data.countCollaboratorActivities = BigInt(data.countCollaboratorActivities.toString());
    }
    if (data.countHomework) {
        data.countHomework = BigInt(data.countHomework.toString());
    }
    if (data.countDailyChallenge) {
        data.countDailyChallenge = BigInt(data.countDailyChallenge.toString());
    }
    if (data.countMonthlyChallenge) {
        data.countMonthlyChallenge = BigInt(data.countMonthlyChallenge.toString());
    }
    if (data.pointsAllLessonsTotal) {
        data.pointsAllLessonsTotal = BigInt(data.pointsAllLessonsTotal.toString());
    }
    if (data.pointsWasteCollectionTotal) {
        data.pointsWasteCollectionTotal = BigInt(data.pointsWasteCollectionTotal.toString());
    }
    if (data.pointsGrandTotal) {
        data.pointsGrandTotal = BigInt(data.pointsGrandTotal.toString());
    }
    if (data.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    if (data.saptamanaVerdeStart) {
        data.saptamanaVerdeStart = new Date(data.saptamanaVerdeStart);
    }
    if (data.saptamanaVerdeEnd) {
        data.saptamanaVerdeEnd = new Date(data.saptamanaVerdeEnd);
    }
    if (data.pointsSchoolChallenge) {
        data.pointsSchoolChallenge = BigInt(data.pointsSchoolChallenge.toString());
    }
    if (data.countSchoolChallenge) {
        data.countSchoolChallenge = BigInt(data.countSchoolChallenge.toString());
    }
    return data;
};

export const getSchoolsReportResponseTransformer = async (data: any): Promise<GetSchoolsReportResponse> => {
    data = pageSchoolReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageSchoolReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return schoolReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const schoolReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.saptamanaVerdeStart) {
        data.saptamanaVerdeStart = new Date(data.saptamanaVerdeStart);
    }
    if (data.saptamanaVerdeEnd) {
        data.saptamanaVerdeEnd = new Date(data.saptamanaVerdeEnd);
    }
    if (data.professor) {
        data.professor = userProfileDtoSchemaResponseTransformer(data.professor);
    }
    if (data.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

export const getOwnSchoolResponseTransformer = async (data: any): Promise<GetOwnSchoolResponse> => {
    data = schoolDtoSchemaResponseTransformer(data);
    return data;
};

export const getSchoolsImportDataResponseTransformer = async (data: any): Promise<GetSchoolsImportDataResponse> => {
    data = pageSchoolDataImportDtoSchemaResponseTransformer(data);
    return data;
};

const pageSchoolDataImportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

export const getDefaultSchoolResponseTransformer = async (data: any): Promise<GetDefaultSchoolResponse> => {
    data = schoolDtoSchemaResponseTransformer(data);
    return data;
};

export const getSchoolRequestByIdResponseTransformer = async (data: any): Promise<GetSchoolRequestByIdResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const getSchoolRequestByUserIdResponseTransformer = async (
    data: any,
): Promise<GetSchoolRequestByUserIdResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const getSchoolRequestsReportResponseTransformer = async (
    data: any,
): Promise<GetSchoolRequestsReportResponse> => {
    data = pageSchoolRequestReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageSchoolRequestReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return schoolRequestReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const schoolRequestReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.saptamanaVerdeStart) {
        data.saptamanaVerdeStart = new Date(data.saptamanaVerdeStart);
    }
    if (data.saptamanaVerdeEnd) {
        data.saptamanaVerdeEnd = new Date(data.saptamanaVerdeEnd);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.timestampRange) {
        data.timestampRange = rangeLocalDateTimeSchemaResponseTransformer(data.timestampRange);
    }
    if (data.professor) {
        data.professor = userDtoSchemaResponseTransformer(data.professor);
    }
    if (data.schoolUpdatedAt) {
        data.schoolUpdatedAt = new Date(data.schoolUpdatedAt);
    }
    if (data.acordGrupWhatsappDt) {
        data.acordGrupWhatsappDt = new Date(data.acordGrupWhatsappDt);
    }
    if (data.profesorActualUltimaActivitate) {
        data.profesorActualUltimaActivitate = new Date(data.profesorActualUltimaActivitate);
    }
    return data;
};

export const getIstoricProfesoriResponseTransformer = async (data: any): Promise<GetIstoricProfesoriResponse> => {
    data = data.map((item: any) => {
        return istoricProfesorDtoSchemaResponseTransformer(item);
    });
    return data;
};

const istoricProfesorDtoSchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = new Date(data.data);
    }
    return data;
};

export const getDefaultSchoolRequestResponseTransformer = async (
    data: any,
): Promise<GetDefaultSchoolRequestResponse> => {
    data = schoolRequestDtoSchemaResponseTransformer(data);
    return data;
};

export const getSchedulerRunsResponseTransformer = async (data: any): Promise<GetSchedulerRunsResponse> => {
    data = pageSchedulerRunDtoSchemaResponseTransformer(data);
    return data;
};

const pageSchedulerRunDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return schedulerRunDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const schedulerRunDtoSchemaResponseTransformer = (data: any) => {
    if (data.startedAt) {
        data.startedAt = new Date(data.startedAt);
    }
    if (data.finishedAt) {
        data.finishedAt = new Date(data.finishedAt);
    }
    return data;
};

export const getParentalApprovalByUserResponseTransformer = async (
    data: any,
): Promise<GetParentalApprovalByUserResponse> => {
    data = parentalApprovalDtoSchemaResponseTransformer(data);
    return data;
};

export const getNotificationByIdResponseTransformer = async (data: any): Promise<GetNotificationByIdResponse> => {
    data = notificationDtoSchemaResponseTransformer(data);
    return data;
};

export const getNotificationReceiversStatusResponseTransformer = async (
    data: any,
): Promise<GetNotificationReceiversStatusResponse> => {
    data = data.map((item: any) => {
        return notificationReadDtoSchemaResponseTransformer(item);
    });
    return data;
};

const notificationReadDtoSchemaResponseTransformer = (data: any) => {
    if (data.readAt) {
        data.readAt = new Date(data.readAt);
    }
    return data;
};

export const getNotificationsReportResponseTransformer = async (data: any): Promise<GetNotificationsReportResponse> => {
    data = pageNotificationReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageNotificationReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return notificationReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const notificationReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.notification) {
        data.notification = notificationDtoSchemaResponseTransformer(data.notification);
    }
    if (data.receiver) {
        data.receiver = userDtoSchemaResponseTransformer(data.receiver);
    }
    if (data.readAt) {
        data.readAt = new Date(data.readAt);
    }
    if (data.readAtRange) {
        data.readAtRange = rangeLocalDateTimeSchemaResponseTransformer(data.readAtRange);
    }
    return data;
};

export const getOutboxNotificationsDeprecatedResponseTransformer = async (
    data: any,
): Promise<GetOutboxNotificationsDeprecatedResponse> => {
    data = pageOutboxNotificationDtoSchemaResponseTransformer(data);
    return data;
};

const pageOutboxNotificationDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return outboxNotificationDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const outboxNotificationDtoSchemaResponseTransformer = (data: any) => {
    if (data.sendAt) {
        data.sendAt = new Date(data.sendAt);
    }
    return data;
};

export const getInboxNotificationsResponseTransformer = async (data: any): Promise<GetInboxNotificationsResponse> => {
    data = pageInboxNotificationDtoSchemaResponseTransformer(data);
    return data;
};

const pageInboxNotificationDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return inboxNotificationDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const inboxNotificationDtoSchemaResponseTransformer = (data: any) => {
    if (data.readAt) {
        data.readAt = new Date(data.readAt);
    }
    if (data.sendAt) {
        data.sendAt = new Date(data.sendAt);
    }
    return data;
};

export const getDefaultNotificationResponseTransformer = async (data: any): Promise<GetDefaultNotificationResponse> => {
    data = notificationDtoSchemaResponseTransformer(data);
    return data;
};

export const getLessonByIdResponseTransformer = async (data: any): Promise<GetLessonByIdResponse> => {
    data = lessonDtoSchemaResponseTransformer(data);
    return data;
};

export const getLessonsByTypeResponseTransformer = async (data: any): Promise<GetLessonsByTypeResponse> => {
    data = data.map((item: any) => {
        return lessonDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const getDefaultLessonResponseTransformer = async (data: any): Promise<GetDefaultLessonResponse> => {
    data = lessonDtoSchemaResponseTransformer(data);
    return data;
};

export const getLessonProgressByTypeResponseTransformer = async (
    data: any,
): Promise<GetLessonProgressByTypeResponse> => {
    data = data.map((item: any) => {
        return lessonProgressDtoSchemaResponseTransformer(item);
    });
    return data;
};

const lessonProgressDtoSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const getAnswersForSubmissionResponseTransformer = async (
    data: any,
): Promise<GetAnswersForSubmissionResponse> => {
    data = data.map((item: any) => {
        return answerDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const getLessonAnswersReportResponseTransformer = async (data: any): Promise<GetLessonAnswersReportResponse> => {
    data = pageLessonAnswerReportDtoSchemaResponseTransformer(data);
    return data;
};

const pageLessonAnswerReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalElements) {
        data.totalElements = BigInt(data.totalElements.toString());
    }
    if (data.content) {
        data.content = data.content.map((item: any) => {
            return lessonAnswerReportDtoSchemaResponseTransformer(item);
        });
    }
    if (data.pageable) {
        data.pageable = pageableObjectSchemaResponseTransformer(data.pageable);
    }
    return data;
};

const lessonAnswerReportDtoSchemaResponseTransformer = (data: any) => {
    if (data.lesson) {
        data.lesson = lessonDtoSchemaResponseTransformer(data.lesson);
    }
    if (data.user) {
        data.user = userDtoSchemaResponseTransformer(data.user);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.startedAt) {
        data.startedAt = new Date(data.startedAt);
    }
    if (data.approvedAt) {
        data.approvedAt = new Date(data.approvedAt);
    }
    if (data.timestampRange) {
        data.timestampRange = rangeLocalDateTimeSchemaResponseTransformer(data.timestampRange);
    }
    if (data.approvedAtRange) {
        data.approvedAtRange = rangeLocalDateTimeSchemaResponseTransformer(data.approvedAtRange);
    }
    return data;
};

export const getEditionByIdResponseTransformer = async (data: any): Promise<GetEditionByIdResponse> => {
    data = editionDtoSchemaResponseTransformer(data);
    return data;
};

export const getDefaultEditionResponseTransformer = async (data: any): Promise<GetDefaultEditionResponse> => {
    data = editionDtoSchemaResponseTransformer(data);
    return data;
};

export const getCollabInfoResponseTransformer = async (data: any): Promise<GetCollabInfoResponse> => {
    data = collabInfoDtoSchemaResponseTransformer(data);
    return data;
};

const collabInfoDtoSchemaResponseTransformer = (data: any) => {
    if (data.activities) {
        data.activities = data.activities.map((item: any) => {
            return activityOptionSchemaResponseTransformer(item);
        });
    }
    return data;
};

const activityOptionSchemaResponseTransformer = (data: any) => {
    if (data.deadline) {
        data.deadline = new Date(data.deadline);
    }
    return data;
};

export const getCollabActivityResponseTransformer = async (data: any): Promise<GetCollabActivityResponse> => {
    data = lessonDtoSchemaResponseTransformer(data);
    return data;
};

export const getAnswerByIdResponseTransformer = async (data: any): Promise<GetAnswerByIdResponse> => {
    data = answerDtoSchemaResponseTransformer(data);
    return data;
};

export const getAnswersByLessonResponseTransformer = async (data: any): Promise<GetAnswersByLessonResponse> => {
    data = data.map((item: any) => {
        return answerDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const getStudentAnswersByLessonAndUserResponseTransformer = async (
    data: any,
): Promise<GetStudentAnswersByLessonAndUserResponse> => {
    data = data.map((item: any) => {
        return answerDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const getDefaultAnswerResponseTransformer = async (data: any): Promise<GetDefaultAnswerResponse> => {
    data = answerDtoSchemaResponseTransformer(data);
    return data;
};

export const analyzeBlobStorageResponseTransformer = async (data: any): Promise<AnalyzeBlobStorageResponse> => {
    data = blobAnalysisResultDtoSchemaResponseTransformer(data);
    return data;
};

const blobAnalysisResultDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalBlobsInAzure) {
        data.totalBlobsInAzure = BigInt(data.totalBlobsInAzure.toString());
    }
    if (data.totalReferencesInDatabase) {
        data.totalReferencesInDatabase = BigInt(data.totalReferencesInDatabase.toString());
    }
    if (data.orphanedBlobsCount) {
        data.orphanedBlobsCount = BigInt(data.orphanedBlobsCount.toString());
    }
    return data;
};
